import { useCallback, useEffect } from "react";
import { ChevronLeft, ChevronRight, X } from "lucide-react";

export default function Lightbox({ images, index, onClose, onPrev, onNext }) {
  const handleKey = useCallback(
    (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") onPrev();
      if (e.key === "ArrowRight") onNext();
    },
    [onClose, onPrev, onNext]
  );

  useEffect(() => {
    if (index === null) return;
    document.addEventListener("keydown", handleKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", handleKey);
      document.body.style.overflow = prev;
    };
  }, [index, handleKey]);

  if (index === null) return null;
  const current = images[index];

  return (
    <div
      data-testid="lightbox-overlay"
      onClick={onClose}
      className="fixed inset-0 z-[100] bg-[#1d140d]/95 backdrop-blur-sm flex items-center justify-center p-4 sm:p-10 animate-in fade-in duration-200"
    >
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
        data-testid="lightbox-close"
        aria-label="Zamknij"
        className="absolute top-5 right-5 w-11 h-11 rounded-full bg-white/10 hover:bg-white/20 text-[#f3e3c6] flex items-center justify-center transition-colors"
      >
        <X className="w-5 h-5" />
      </button>

      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          onPrev();
        }}
        data-testid="lightbox-prev"
        aria-label="Poprzednie"
        className="absolute left-3 sm:left-6 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 text-[#f3e3c6] flex items-center justify-center transition-colors"
      >
        <ChevronLeft className="w-6 h-6" />
      </button>

      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          onNext();
        }}
        data-testid="lightbox-next"
        aria-label="Następne"
        className="absolute right-3 sm:right-6 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 text-[#f3e3c6] flex items-center justify-center transition-colors"
      >
        <ChevronRight className="w-6 h-6" />
      </button>

      <figure
        onClick={(e) => e.stopPropagation()}
        className="relative max-w-[90vw] max-h-[88vh] flex flex-col items-center"
      >
        <img
          src={current.src}
          alt={current.alt}
          data-testid="lightbox-image"
          className="max-w-full max-h-[82vh] object-contain rounded-lg shadow-2xl"
        />
        <figcaption className="mt-4 text-sm text-[#e7d8bc]/75 tracking-wide">
          {index + 1} / {images.length} · {current.alt}
        </figcaption>
      </figure>
    </div>
  );
}
